import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/**
 * Reusable page header with title, optional subtitle, and a back button.
 *
 * Props:
 *   title    - main heading text
 *   subtitle - optional description below the title
 *   onBack   - shows a back button by default (goes back in history).
 *              Pass a function for custom navigation, or `false` to hide it.
 */
const PageHeader = ({ title, subtitle, onBack = true }) => {
  const navigate = useNavigate();
  const handleBack = onBack === true ? () => navigate(-1) : onBack;

  return (
    <div className="pt-1 pb-4">
      {handleBack && (
        <button
          type="button"
          onClick={handleBack}
          title="Go back"
          className="d-flex align-items-center gap-1 mb-1"
          style={{
            border: "none",
            background: "transparent",
            padding: 0,
            fontSize: "13px",
            fontWeight: 600,
            color: "var(--app-icon-color, #a70e13)",
            cursor: "pointer",
          }}
        >
          <ArrowBackIcon style={{ fontSize: 16 }} />
          Go Back
        </button>
      )}
      <h1 style={{ fontSize: "28px", fontWeight: 700, color: "#1a1a2e", margin: 0 }}>{title}</h1>
      {subtitle && (
        <p style={{ fontSize: "13px", color: "#9ca3af", margin: "4px 0 0 0" }}>{subtitle}</p>
      )}
    </div>
  );
};

export default PageHeader;
